import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { FiMenu } from "react-icons/fi";
import { ImCross } from "react-icons/im";
const Header = () => {
  const [scroll, setScroll] = useState(false);
  const [open, setOpen] = useState(false);
  const handleScroll = () => {
    if (window.scrollY > 20) {
      setScroll(true);
    } else {
      setScroll(false);
    }
  };
  const handleMenuToggle = () => {
    setOpen(!open);
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav
      className={`${
        scroll
          ? "bg-white shadow-md text-gray-700 hover:text-black"
          : "bg-inherit text-white"
      } fixed w-full z-50 transition duration-500 `}
    >
      <div className="container mx-auto px-2 py-3 flex items-center justify-around ">
        <Link to="/">
          <h1 className=" tracking-widest font-bold ">RAHAT </h1>
          <p>PHOTOGRAPHY </p>
        </Link>
        <div className="hidden md:flex md:items-center md:justify-center">
          <Link to="/" className="mx-3 font-medium">
            Home
          </Link>
          <Link to="/Specialties" className="mx-3 font-medium">
            Specialties
          </Link>
          <Link to="/Portfolio" className="mx-3 font-medium">
            Portfolio
          </Link>

          <Link to="/PhotoGallery" className="mx-3 font-medium">
            Gallery
          </Link>
          <Link to="/AboutMe" className="mx-3 font-medium">
            About Me
          </Link>
          <Link to="/contact" className="mx-3 font-medium">
            Contact
          </Link>
        </div>

        <div className="md:hidden flex items-center">
          <button
            onClick={handleMenuToggle}
            className={`${
              open ? "text-white" : "text-white"
            } focus:outline-none hover:text-gray-400`}
          >
            {open ? <ImCross size={24} /> : <FiMenu size={24} />}
          </button>
        </div>
      </div>
      <div
        className={`${open ? "block" : "hidden"} md:hidden text-black bg-white`}
      >
        <Link to="/" className="mx-3 font-medium">
          Home
        </Link>
        <Link to="/Specialties" className="mx-3 font-medium">
          Specialties
        </Link>
        <Link to="/Portfolio" className="mx-3 font-medium">
          Portfolio
        </Link>

        <Link to="/PhotoGallery" className="mx-3 font-medium">
          Gallery
        </Link>
        <Link to="/AboutMe" className="mx-3 font-medium">
          About Me
        </Link>
        <Link to="/contact" className="mx-3 font-medium">
          Contact
        </Link>
      </div>
    </nav>
  );
};

export default Header;
